module.exports = __webpack_public_path__ + "static/media/update-profile-bg.12eb99c2.png";